import { defineStore } from 'pinia'
import { env } from '@/helpers/env.js'
import { fetchWrapper } from '@/helpers/fetch-wrapper'
import { isIosApp, isAndroidApp } from '@/helpers/utils'

export const useProfileStore = defineStore({
  id: 'profile',
  state: () => ({
    profile: JSON.parse(localStorage.getItem('profile')),
    lastProfileCheck: null,
  }),
  actions: {
    async fetchProfile(lazy = false) {
      const now = new Date().getTime();

      // If lazy is true and the profile was fetched recently, skip fetching
      if (lazy && this.lastProfileCheck && now - this.lastProfileCheck < 5 * 60 * 1000) { // 5 minutes
        return;
      }

      var platform = ''
      if (isIosApp) {
        platform = 'ios'
      } else if (isAndroidApp) {
        platform = 'android'
      } else {
        platform = 'web'
      }
      const profile = await fetchWrapper.get(`/profile/?release_version=${env.VUE_APP_RELEASE_VERSION}&platform=${platform}`)
      this.profile = profile;
      this.lastProfileCheck = now;
      localStorage.setItem('profile', JSON.stringify(profile));
    },
    async changeLanguage(language) {
      this.profile.learning_language = language;
      await fetchWrapper.patch(`/profile/`, { learning_language: language });
    },
    async changeAutoPlay(autoPlay) {
      this.profile.auto_play = autoPlay;
      await fetchWrapper.patch(`/profile/`, { auto_play: autoPlay });
    }
  }
});

